import axios from "axios";
import { store as storeNotification } from "react-notifications-component";
import {
	FILE_SELECTING,
	FILE_UNSELECTING,
	FILE_UPLOADED,
	FILE_UPLOADING,
	IMAGE_SELECTING,
	IMAGE_UNSELECTING,
	IMAGE_UPLOADED,
	IMAGE_UPLOADING,
} from "./types";

export const fileUploadActions = (listdata) => (dispatch) => {
	dispatch({ type: FILE_UPLOADING });

	let formData = new FormData(); //formdata object
	console.log("fileUploadActions input data=", listdata);

	listdata.data.map((listdata) => {
		formData.append(listdata.name, listdata.value); //append the values with key, value pair
	});
	const token = localStorage.getItem("token");
	const config = {
		headers: {
			"x-auth-token": token,
			"content-type": "multipart/form-data",
		},
	};

	axios
		.post(listdata.url, formData, config)
		.then((response) => {
			console.log("fileUploadActions=", response);
			if (response) {
				storeNotification.addNotification({
					title: "File!",
					message: "File was uploaded",
					type: "success",
					insert: "top",
					container: "top-right",
					animationIn: ["animated", "fadeIn"],
					animationOut: ["animated", "fadeOut"],
					dismiss: {
						duration: 5000,
						onScreen: true,
					},
				});
				return dispatch({
					type: FILE_UPLOADED,
					payload: response.data.message._id,
				});
			}
		})
		.catch((error) => {
			storeNotification.addNotification({
				title: "File!",
				message: "Failed to upload",
				type: "danger",
				insert: "top",
				container: "top-right",
				animationIn: ["animated", "fadeIn"],
				animationOut: ["animated", "fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});
			console.log("fileUploadActions error=", error);
		});
};
export const fileSelectionActions = (data) => (dispatch) => {
	console.log("fileSelectionActions data=", data);

	dispatch({ type: FILE_SELECTING, payload: { file: data.file, id: data.id } });
	storeNotification.addNotification({
		title: "File!",
		message: "File was selected",
		type: "success",
		insert: "top",
		container: "top-right",
		animationIn: ["animated", "fadeIn"],
		animationOut: ["animated", "fadeOut"],
		dismiss: {
			duration: 5000,
			onScreen: true,
		},
	});
};
export const fileUnSelectionActions = (data) => (dispatch) => {
	console.log("fileUnSelectionActions action data=", data);

	dispatch({
		type: FILE_UNSELECTING,
		payload: { id: data },
	});
};

export const imageUploadActions = (listdata) => (dispatch) => {
	dispatch({ type: IMAGE_UPLOADING });

	let formData = new FormData(); //formdata object
	console.log("imageUploadActions input data=", listdata);

	listdata.data.map((listdata) => {
		formData.append(listdata.name, listdata.value); //append the values with key, value pair
	});
	const token = localStorage.getItem("token");
	const config = {
		headers: {
			"x-auth-token": token,
			"content-type": "multipart/form-data",
		},
	};

	axios
		.post(listdata.url, formData, config)
		.then((response) => {
			console.log("imageUploadActions response=", response);
			if (response) {
				storeNotification.addNotification({
					title: "Image!",
					message: "Image was uploaded",
					type: "success",
					insert: "top",
					container: "top-right",
					animationIn: ["animated", "fadeIn"],
					animationOut: ["animated", "fadeOut"],
					dismiss: {
						duration: 5000,
						onScreen: true,
					},
				});
				return dispatch({
					type: IMAGE_UPLOADED,
					payload: response,
				});
			}
		})
		.catch((error) => {
			console.log("imageUploadActions error=", error);
		});
};

export const imageSelectionActions = (data) => (dispatch) => {
	console.log("imageSelectionActions data=", data);

	dispatch({
		type: IMAGE_SELECTING,
		payload: { file: data },
	});
};
export const imageUnSelectionActions = (data) => (dispatch) => {
	console.log("imageUnSelectionActions action data=", data);

	dispatch({
		type: IMAGE_UNSELECTING,
	});
};
